(function () {
  const DEFAULT_OPTIONS = [
    { icon: 'profile', title: 'Meu perfil', url: '/account' },
    { icon: 'bag', title: 'Meus pedidos', url: '/orders' },
    { icon: 'heart', title: 'Minhas listas', url: '/pages/favoritos' },
    { icon: 'creditCard', title: 'Meus cart\u00F5es', url: '/pages/cartoes' },
  ];

  const DEFAULT_PHRASE = 'Voc\u00EA tem benef\u00EDcios exclusivos para aproveitar seus descontos.';
  const DEFAULT_COLOR = '#173F83';
  const MIN_APP_VERSION = 260820;
  const DEFAULT_COUPON_RULES = {
    couponValidityHours: '24',
    couponDiscountPercentage: '20',
    couponMinimumPurchase: '0',
    couponMaxDiscount: '',
    couponSalesChannels: '',
  };

  const state = {
    initialized: false,
    disabled: false,
    appVersion: 0,
    handlers: {},
    saved: null,
    draft: null,
    couponRulesSaved: null,
    couponRulesDraft: null,
    checkoutStore: '',
    primaryColor: DEFAULT_COLOR,
    previewStep: 'menu',
    panelObserver: null,
    dom: {},
  };

  function cloneOptions(options) {
    return (options || []).map((item) => ({
      icon: String((item && item.icon) || 'gift'),
      title: String((item && item.title) || ''),
      url: String((item && item.url) || ''),
    }));
  }

  function cloneSidebar(sidebar) {
    const source = sidebar || {};
    return {
      topImage: String(source.topImage || ''),
      phrase: String(source.phrase || ''),
      benefitsEnabled: source.benefitsEnabled === true,
      benefitsBadgeColor: normalizeColor(source.benefitsBadgeColor, DEFAULT_COLOR),
      options: cloneOptions(source.options),
    };
  }

  function normalizeCouponRules(value) {
    const source = value && typeof value === 'object' ? value : {};
    const normalized = {};
    Object.keys(DEFAULT_COUPON_RULES).forEach((key) => {
      const current = source[key];
      if (key === 'couponSalesChannels') {
        normalized[key] = Array.isArray(current)
          ? current.join(', ')
          : String(current == null ? DEFAULT_COUPON_RULES[key] : current);
        return;
      }
      normalized[key] = String(current == null || current === ''
        ? DEFAULT_COUPON_RULES[key]
        : current);
    });
    if (source.couponMaxDiscount == null || source.couponMaxDiscount === '') {
      normalized.couponMaxDiscount = '';
    }
    return normalized;
  }

  function cloneCouponRules(value) {
    return { ...normalizeCouponRules(value) };
  }

  function comparableCouponRules(value) {
    const normalized = normalizeCouponRules(value);
    Object.keys(normalized).forEach((key) => {
      normalized[key] = normalized[key].trim().replace(/\s*,\s*/g, ',');
    });
    return JSON.stringify(normalized);
  }

  function shouldShowCouponRules() {
    return state.checkoutStore === 'uappi' && state.draft && state.draft.benefitsEnabled;
  }

  function normalizeOptions(value) {
    const list = Array.isArray(value)
      ? value
      : value && typeof value === 'object'
        ? Object.values(value)
        : null;

    if (!list) {
      return cloneOptions(DEFAULT_OPTIONS);
    }

    return list
      .filter((item) => item && typeof item === 'object')
      .map((item) => ({
        icon: String(item.icon || 'gift').trim() || 'gift',
        title: String(item.title || ''),
        url: String(item.url || ''),
      }));
  }

  function normalizeSidebar(value) {
    const source = value && typeof value === 'object' ? value : {};
    const hasOwn = (key) => Object.prototype.hasOwnProperty.call(source, key);

    return {
      topImage: hasOwn('topImage') ? String(source.topImage || '') : '',
      phrase: hasOwn('phrase') ? String(source.phrase || '') : DEFAULT_PHRASE,
      benefitsEnabled: source.benefitsEnabled === true,
      benefitsBadgeColor: normalizeColor(source.benefitsBadgeColor, DEFAULT_COLOR),
      options: hasOwn('options') ? normalizeOptions(source.options) : cloneOptions(DEFAULT_OPTIONS),
    };
  }

  function normalizeColor(value, fallback) {
    const color = String(value || '').trim();
    return /^#[0-9a-f]{6}$/i.test(color) ? color.toUpperCase() : fallback;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function humanize(value) {
    const text = String(value || '')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([0-9]+)/g, ' $1 ')
      .replace(/\s+/g, ' ')
      .trim();
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : '\u00CDcone';
  }

  function getIconItems() {
    const catalog = window.AppMenuIconCatalog;
    const list = catalog && catalog.iconSets && catalog.iconSets.phosphor
      ? catalog.iconSets.phosphor.regular
      : null;
    return Array.isArray(list) ? list : [];
  }

  function getIconMeta(key) {
    return getIconItems().find((item) => item.key === key) || null;
  }

  function getIconGlyph(key) {
    const item = getIconMeta(key);
    const codepoint = item && item.codepoint ? parseInt(item.codepoint, 16) : null;
    return Number.isFinite(codepoint) ? String.fromCodePoint(codepoint) : '\u25A1';
  }

  function iconSelectMarkup(selectedKey) {
    const items = getIconItems();
    const hasSelected = items.some((item) => item.key === selectedKey);
    const custom = !hasSelected && selectedKey
      ? '<option value="' + escapeHtml(selectedKey) + '" selected>' + escapeHtml(humanize(selectedKey)) + '</option>'
      : '';
    let lastCategory = null;

    return custom + items.map((item) => {
      const category = item.category || 'Outros';
      const prefix = category !== lastCategory ? category + ' - ' : '';
      lastCategory = category;
      return '<option value="' + escapeHtml(item.key) + '"' + (item.key === selectedKey ? ' selected' : '') + '>'
        + escapeHtml(prefix + humanize(item.key))
        + '</option>';
    }).join('');
  }

  function cacheDom() {
    state.dom.panel = document.getElementById('appMenuPanelSidebar');
    state.dom.status = document.getElementById('appSidebarSaveStatus');
    state.dom.versionNotice = document.getElementById('appSidebarVersionNotice');
    state.dom.topImage = document.getElementById('appSidebarTopImage');
    state.dom.phrase = document.getElementById('appSidebarPhrase');
    state.dom.phraseCounter = document.getElementById('appSidebarPhraseCounter');
    state.dom.benefitsEnabled = document.getElementById('appSidebarBenefitsEnabled');
    state.dom.badgeColorField = document.getElementById('appSidebarBadgeColorField');
    state.dom.badgeColor = document.getElementById('appSidebarBadgeColor');
    state.dom.badgeColorText = document.getElementById('appSidebarBadgeColorText');
    state.dom.couponRules = document.getElementById('appSidebarCouponRules');
    state.dom.couponValidityHours = document.getElementById('appSidebarCouponValidityHours');
    state.dom.couponDiscountPercentage = document.getElementById('appSidebarCouponDiscountPercentage');
    state.dom.couponMinimumPurchase = document.getElementById('appSidebarCouponMinimumPurchase');
    state.dom.couponMaxDiscount = document.getElementById('appSidebarCouponMaxDiscount');
    state.dom.couponSalesChannels = document.getElementById('appSidebarCouponSalesChannels');
    state.dom.options = document.getElementById('appSidebarOptions');
    state.dom.optionsEmpty = document.getElementById('appSidebarOptionsEmpty');
    state.dom.addOption = document.getElementById('appSidebarAddOption');
    state.dom.reset = document.getElementById('appSidebarReset');
    state.dom.save = document.getElementById('appSidebarSave');
    state.dom.saveLabel = document.getElementById('appSidebarSaveLabel');
    state.dom.phone = document.getElementById('appSidebarPhone');
    state.dom.previewImage = document.getElementById('appSidebarPreviewImage');
    state.dom.previewBrand = document.getElementById('appSidebarPreviewBrand');
    state.dom.previewPhrase = document.getElementById('appSidebarPreviewPhrase');
    state.dom.previewBenefits = document.getElementById('appSidebarPreviewBenefits');
    state.dom.previewBenefitsButton = document.getElementById('appSidebarBenefitsPreviewButton');
    state.dom.previewOptionsSection = document.getElementById('appSidebarPreviewOptionsSection');
    state.dom.previewOptions = document.getElementById('appSidebarPreviewOptions');
    state.dom.previewClose = document.getElementById('appSidebarPreviewClose');
    state.dom.previewCouponDiscount = document.getElementById('appSidebarPreviewCouponDiscount');
    state.dom.previewCouponValidity = document.getElementById('appSidebarPreviewCouponValidity');
  }

  function isVersionSupported() {
    return state.appVersion >= MIN_APP_VERSION;
  }

  function showToast(message, type) {
    if (typeof state.handlers.toast === 'function') {
      state.handlers.toast(message, type || 'info');
      return;
    }
    if (window.NioApp && typeof window.NioApp.Toast === 'function') {
      window.NioApp.Toast(message, type || 'info');
    }
  }

  function setStatus(status, label) {
    if (!state.dom.status) return;
    state.dom.status.dataset.status = status;
    state.dom.status.textContent = label;
  }

  function comparable(sidebar) {
    const value = cloneSidebar(sidebar);
    value.topImage = value.topImage.trim();
    value.phrase = value.phrase.trim();
    value.benefitsBadgeColor = normalizeColor(value.benefitsBadgeColor, DEFAULT_COLOR);
    value.options = value.options.map((item) => ({
      icon: item.icon.trim(),
      title: item.title.trim(),
      url: item.url.trim(),
    }));
    return JSON.stringify(value);
  }

  function isDirty() {
    return comparable(state.saved) !== comparable(state.draft)
      || comparableCouponRules(state.couponRulesSaved) !== comparableCouponRules(state.couponRulesDraft);
  }

  function renderCouponRules() {
    if (!state.dom.couponRules || !state.couponRulesDraft) return;
    state.dom.couponRules.hidden = !shouldShowCouponRules();
    state.dom.couponValidityHours.value = state.couponRulesDraft.couponValidityHours;
    state.dom.couponDiscountPercentage.value = state.couponRulesDraft.couponDiscountPercentage;
    state.dom.couponMinimumPurchase.value = state.couponRulesDraft.couponMinimumPurchase;
    state.dom.couponMaxDiscount.value = state.couponRulesDraft.couponMaxDiscount;
    state.dom.couponSalesChannels.value = state.couponRulesDraft.couponSalesChannels;
  }

  function refreshStatus() {
    if (state.disabled) {
      setStatus('locked', 'Indispon\u00EDvel');
      return;
    }
    if (!isVersionSupported()) {
      setStatus('locked', 'Somente pr\u00E9via');
      return;
    }
    if (isDirty()) {
      setStatus('dirty', 'Altera\u00E7\u00F5es pendentes');
    } else {
      setStatus('saved', 'Salvo');
    }
  }

  function renderForm() {
    if (!state.draft) return;
    const versionSupported = isVersionSupported();
    state.dom.topImage.value = state.draft.topImage;
    state.dom.phrase.value = state.draft.phrase;
    state.dom.phraseCounter.textContent = state.draft.phrase.length + '/180';
    state.dom.benefitsEnabled.checked = state.draft.benefitsEnabled;
    state.dom.badgeColorField.hidden = !state.draft.benefitsEnabled;
    state.dom.badgeColor.value = normalizeColor(state.draft.benefitsBadgeColor, DEFAULT_COLOR).toLowerCase();
    state.dom.badgeColorText.value = normalizeColor(state.draft.benefitsBadgeColor, DEFAULT_COLOR);
    state.dom.versionNotice.hidden = state.disabled || versionSupported;
    state.dom.save.disabled = state.disabled || !versionSupported;
    state.dom.saveLabel.textContent = !state.disabled && !versionSupported
      ? 'Requer atualização'
      : 'Salvar menu lateral';
    renderCouponRules();
    renderOptionsEditor();
  }

  function renderOptionsEditor() {
    const options = state.draft ? state.draft.options : [];
    state.dom.options.innerHTML = options.map((item, index) => {
      const disabled = state.disabled ? ' disabled' : '';
      return '<div class="app-sidebar-option" data-sidebar-option="' + index + '">'
        + '<span class="app-sidebar-option__index" aria-hidden="true">' + (index + 1) + '</span>'
        + '<div class="app-sidebar-option__field">'
        + '<label for="appSidebarOptionTitle' + index + '">T\u00EDtulo</label>'
        + '<input id="appSidebarOptionTitle' + index + '" class="form-control" type="text" maxlength="40" data-sidebar-field="title" value="' + escapeHtml(item.title) + '" placeholder="Ex. Meu perfil"' + disabled + '>'
        + '</div>'
        + '<div class="app-sidebar-option__field app-sidebar-option__field--url">'
        + '<label for="appSidebarOptionUrl' + index + '">Destino</label>'
        + '<input id="appSidebarOptionUrl' + index + '" class="form-control" type="text" maxlength="300" data-sidebar-field="url" value="' + escapeHtml(item.url) + '" placeholder="/account"' + disabled + '>'
        + '</div>'
        + '<div class="app-sidebar-option__field">'
        + '<label for="appSidebarOptionIcon' + index + '">\u00CDcone</label>'
        + '<select id="appSidebarOptionIcon' + index + '" class="form-select" data-sidebar-field="icon"' + disabled + '>' + iconSelectMarkup(item.icon) + '</select>'
        + '</div>'
        + '<div class="app-sidebar-option__actions">'
        + '<button type="button" data-sidebar-move="up" aria-label="Mover ' + escapeHtml(item.title || 'atalho') + ' para cima"' + (state.disabled || index === 0 ? ' disabled' : '') + '><em class="icon ni ni-arrow-up"></em></button>'
        + '<button type="button" data-sidebar-move="down" aria-label="Mover ' + escapeHtml(item.title || 'atalho') + ' para baixo"' + (state.disabled || index === options.length - 1 ? ' disabled' : '') + '><em class="icon ni ni-arrow-down"></em></button>'
        + '<button type="button" data-sidebar-remove aria-label="Remover ' + escapeHtml(item.title || 'atalho') + '"' + disabled + '><em class="icon ni ni-trash"></em></button>'
        + '</div>'
        + '</div>';
    }).join('');

    state.dom.optionsEmpty.hidden = options.length > 0;
  }

  function renderPreviewOptions() {
    const options = state.draft ? state.draft.options : [];
    state.dom.previewOptions.textContent = '';
    options.forEach((item) => {
      if (!item.title.trim()) return;
      const row = document.createElement('div');
      row.className = 'app-sidebar-preview-option';

      const icon = document.createElement('span');
      icon.className = 'app-sidebar-preview-option__icon';
      icon.textContent = getIconGlyph(item.icon);

      const label = document.createElement('strong');
      label.textContent = item.title;

      const chevron = document.createElement('i');
      chevron.innerHTML = '&rsaquo;';

      row.append(icon, label, chevron);
      state.dom.previewOptions.appendChild(row);
    });
    state.dom.previewOptionsSection.hidden = state.dom.previewOptions.childElementCount === 0;
  }

  function renderPreviewImage() {
    const value = state.draft.topImage.trim();
    const canPreview = /^https:\/\//i.test(value);
    state.dom.previewImage.hidden = !canPreview;
    state.dom.previewBrand.hidden = canPreview;
    if (canPreview) {
      state.dom.previewImage.src = value;
    } else {
      state.dom.previewImage.removeAttribute('src');
    }
  }

  function renderPreview() {
    if (!state.draft) return;
    const badgeColor = normalizeColor(state.draft.benefitsBadgeColor, state.primaryColor);
    const discount = Number(state.couponRulesDraft && state.couponRulesDraft.couponDiscountPercentage) || 20;
    const validity = Number(state.couponRulesDraft && state.couponRulesDraft.couponValidityHours) || 24;
    state.dom.phone.style.setProperty('--sidebar-brand', state.primaryColor);
    state.dom.phone.style.setProperty('--sidebar-badge', badgeColor);
    state.dom.previewPhrase.textContent = state.draft.phrase;
    state.dom.previewBenefits.hidden = !state.draft.benefitsEnabled;
    state.dom.previewBenefitsButton.hidden = !state.draft.benefitsEnabled;
    state.dom.previewCouponDiscount.textContent = discount + '% de desconto';
    state.dom.previewCouponValidity.textContent = 'V\u00E1lido por ' + validity + 'h';

    if (!state.draft.benefitsEnabled && state.previewStep === 'benefits') {
      state.previewStep = 'menu';
    }

    renderPreviewImage();
    renderPreviewOptions();
    renderPreviewStep();
  }

  function renderPreviewStep() {
    const isBenefits = state.previewStep === 'benefits' && state.draft.benefitsEnabled;
    state.dom.phone.classList.toggle('is-benefits', isBenefits);
    document.querySelectorAll('.app-sidebar-preview-switcher [data-sidebar-preview-step]').forEach((button) => {
      const active = button.dataset.sidebarPreviewStep === (isBenefits ? 'benefits' : 'menu');
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function renderAll() {
    renderForm();
    renderPreview();
    refreshStatus();
  }

  function updateDraftFromBaseField(target) {
    if (!state.draft) return;

    if (target === state.dom.topImage) {
      state.draft.topImage = target.value;
    } else if (target === state.dom.phrase) {
      state.draft.phrase = target.value.slice(0, 180);
      state.dom.phraseCounter.textContent = state.draft.phrase.length + '/180';
    } else if (target === state.dom.benefitsEnabled) {
      state.draft.benefitsEnabled = !!target.checked;
      state.dom.badgeColorField.hidden = !state.draft.benefitsEnabled;
    } else if (target === state.dom.badgeColor) {
      state.draft.benefitsBadgeColor = target.value.toUpperCase();
      state.dom.badgeColorText.value = state.draft.benefitsBadgeColor;
    } else if (target === state.dom.badgeColorText) {
      state.draft.benefitsBadgeColor = target.value.toUpperCase();
      if (/^#[0-9a-f]{6}$/i.test(target.value)) {
        state.dom.badgeColor.value = target.value.toLowerCase();
        target.classList.remove('is-invalid');
      }
    }

    renderCouponRules();
    renderPreview();
    refreshStatus();
  }

  function handleCouponRuleInput(target) {
    const key = target.dataset.couponRule;
    if (!key || !state.couponRulesDraft || !Object.prototype.hasOwnProperty.call(state.couponRulesDraft, key)) {
      return;
    }
    state.couponRulesDraft[key] = target.value;
    target.classList.remove('is-invalid');
    renderPreview();
    refreshStatus();
  }

  function handleOptionInput(target) {
    const wrapper = target.closest('[data-sidebar-option]');
    const field = target.dataset.sidebarField;
    if (!wrapper || !field || !state.draft) return;
    const index = Number(wrapper.dataset.sidebarOption);
    if (!state.draft.options[index]) return;
    state.draft.options[index][field] = target.value;
    target.classList.remove('is-invalid');
    renderPreviewOptions();
    refreshStatus();
  }

  function addOption() {
    if (state.disabled || !state.draft) return;
    state.draft.options.push({ icon: 'gift', title: '', url: '' });
    renderOptionsEditor();
    renderPreviewOptions();
    refreshStatus();
    const input = state.dom.options.querySelector('[data-sidebar-option="' + (state.draft.options.length - 1) + '"] [data-sidebar-field="title"]');
    if (input) input.focus();
  }

  function handleOptionAction(button) {
    if (state.disabled || !state.draft) return;
    const wrapper = button.closest('[data-sidebar-option]');
    if (!wrapper) return;
    const index = Number(wrapper.dataset.sidebarOption);
    if (!state.draft.options[index]) return;

    if (button.hasAttribute('data-sidebar-remove')) {
      state.draft.options.splice(index, 1);
    } else {
      const direction = button.dataset.sidebarMove;
      const nextIndex = direction === 'up' ? index - 1 : index + 1;
      if (nextIndex < 0 || nextIndex >= state.draft.options.length) return;
      const current = state.draft.options[index];
      state.draft.options[index] = state.draft.options[nextIndex];
      state.draft.options[nextIndex] = current;
    }

    renderOptionsEditor();
    renderPreviewOptions();
    refreshStatus();
  }

  function validate() {
    let firstInvalid = null;
    const markInvalid = (element) => {
      element.classList.add('is-invalid');
      if (!firstInvalid) firstInvalid = element;
    };

    state.dom.topImage.classList.remove('is-invalid');
    state.dom.badgeColorText.classList.remove('is-invalid');
    state.dom.options.querySelectorAll('.is-invalid').forEach((element) => element.classList.remove('is-invalid'));
    [
      state.dom.couponValidityHours,
      state.dom.couponDiscountPercentage,
      state.dom.couponMinimumPurchase,
      state.dom.couponMaxDiscount,
      state.dom.couponSalesChannels,
    ].forEach((element) => element.classList.remove('is-invalid'));

    const topImage = state.draft.topImage.trim();
    if (topImage && !/^https:\/\//i.test(topImage)) {
      markInvalid(state.dom.topImage);
    }

    if (!/^#[0-9a-f]{6}$/i.test(state.draft.benefitsBadgeColor)) {
      markInvalid(state.dom.badgeColorText);
    }

    state.draft.options.forEach((item, index) => {
      const wrapper = state.dom.options.querySelector('[data-sidebar-option="' + index + '"]');
      if (!wrapper) return;
      if (!item.title.trim()) markInvalid(wrapper.querySelector('[data-sidebar-field="title"]'));
      if (!item.url.trim()) markInvalid(wrapper.querySelector('[data-sidebar-field="url"]'));
    });

    if (shouldShowCouponRules()) {
      const validateNumber = (element, minimum, maximum, optional) => {
        const raw = element.value.trim();
        if (optional && !raw) return;
        const number = Number(raw);
        if (!raw || !Number.isFinite(number) || number < minimum || number > maximum) {
          markInvalid(element);
        }
      };
      validateNumber(state.dom.couponValidityHours, 1, 8760, false);
      validateNumber(state.dom.couponDiscountPercentage, 0.01, 100, false);
      validateNumber(state.dom.couponMinimumPurchase, 0, 100000000, false);
      validateNumber(state.dom.couponMaxDiscount, 0.01, 100000000, true);

      const channels = state.dom.couponSalesChannels.value.trim();
      if (channels && !/^\d+(?:\s*,\s*\d+)*$/.test(channels)) {
        markInvalid(state.dom.couponSalesChannels);
      }
    }

    if (firstInvalid) {
      firstInvalid.focus();
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      showToast('Revise os campos destacados antes de salvar.', 'error');
      return false;
    }

    return true;
  }

  function buildPayload() {
    return {
      topImage: state.draft.topImage.trim(),
      phrase: state.draft.phrase.trim(),
      benefitsEnabled: !!state.draft.benefitsEnabled,
      benefitsBadgeColor: normalizeColor(state.draft.benefitsBadgeColor, DEFAULT_COLOR),
      options: state.draft.options.map((item) => ({
        icon: item.icon.trim() || 'gift',
        title: item.title.trim(),
        url: item.url.trim(),
      })),
    };
  }

  function buildCouponRulesPayload() {
    const source = state.couponRulesDraft;
    const channels = source.couponSalesChannels
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean)
      .map(Number);
    return {
      couponValidityHours: Number(source.couponValidityHours),
      couponDiscountPercentage: Number(source.couponDiscountPercentage),
      couponMinimumPurchase: Number(source.couponMinimumPurchase),
      couponMaxDiscount: source.couponMaxDiscount.trim() === '' ? null : Number(source.couponMaxDiscount),
      couponSalesChannels: channels.length ? channels : null,
    };
  }

  async function save() {
    if (state.disabled || !state.draft) return;
    if (!isVersionSupported()) {
      showToast('Solicite uma atualização do app para ativar o menu lateral.', 'warning');
      return;
    }
    if (!validate()) return;
    const payload = buildPayload();
    const saveCouponRules = shouldShowCouponRules();
    const couponRulesPayload = saveCouponRules ? buildCouponRulesPayload() : null;
    setStatus('saving', 'Salvando...');
    state.dom.save.disabled = true;

    try {
      const writes = [];
      if (typeof state.handlers.saveSidebar === 'function') writes.push(state.handlers.saveSidebar(payload));
      if (saveCouponRules && typeof state.handlers.saveCouponRules === 'function') {
        writes.push(state.handlers.saveCouponRules(couponRulesPayload));
      }
      await Promise.all(writes);
      state.saved = cloneSidebar(payload);
      state.draft = cloneSidebar(payload);
      if (saveCouponRules) {
        state.couponRulesSaved = normalizeCouponRules(couponRulesPayload);
      }
      state.couponRulesDraft = cloneCouponRules(state.couponRulesSaved);
      renderAll();
      showToast('Menu lateral salvo. Reinicie o app para visualizar.', 'success');
    } catch (error) {
      setStatus('error', 'Erro ao salvar');
      showToast(error && error.message
        ? error.message
        : 'N\u00E3o foi poss\u00EDvel salvar o menu lateral. Tente novamente.', 'error');
    } finally {
      state.dom.save.disabled = state.disabled || !isVersionSupported();
    }
  }

  function reset() {
    if (state.disabled || !state.saved) return;
    state.draft = cloneSidebar(state.saved);
    state.couponRulesDraft = cloneCouponRules(state.couponRulesSaved);
    renderAll();
  }

  function setPreviewStep(step) {
    state.previewStep = step === 'benefits' && state.draft.benefitsEnabled ? 'benefits' : 'menu';
    if (!state.dom.phone.classList.contains('is-open')) {
      state.dom.phone.classList.add('is-open');
    }
    renderPreviewStep();
  }

  function animateOpen() {
    state.previewStep = 'menu';
    renderPreviewStep();
    state.dom.phone.classList.remove('is-open');
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => state.dom.phone.classList.add('is-open'));
    });
  }

  function bindEvents() {
    [state.dom.topImage, state.dom.phrase, state.dom.badgeColorText].forEach((element) => {
      element.addEventListener('input', (event) => updateDraftFromBaseField(event.target));
    });
    [state.dom.benefitsEnabled, state.dom.badgeColor].forEach((element) => {
      element.addEventListener('change', (event) => updateDraftFromBaseField(event.target));
    });
    [
      state.dom.couponValidityHours,
      state.dom.couponDiscountPercentage,
      state.dom.couponMinimumPurchase,
      state.dom.couponMaxDiscount,
      state.dom.couponSalesChannels,
    ].forEach((element) => {
      element.addEventListener('input', (event) => handleCouponRuleInput(event.target));
    });

    state.dom.options.addEventListener('input', (event) => handleOptionInput(event.target));
    state.dom.options.addEventListener('change', (event) => handleOptionInput(event.target));
    state.dom.options.addEventListener('click', (event) => {
      const button = event.target.closest('[data-sidebar-move], [data-sidebar-remove]');
      if (button) handleOptionAction(button);
    });

    state.dom.addOption.addEventListener('click', addOption);
    state.dom.reset.addEventListener('click', reset);
    state.dom.save.addEventListener('click', save);
    state.dom.previewClose.addEventListener('click', () => state.dom.phone.classList.remove('is-open'));
    state.dom.previewBenefits.addEventListener('click', () => setPreviewStep('benefits'));

    state.dom.panel.addEventListener('click', (event) => {
      const button = event.target.closest('[data-sidebar-preview-step]');
      if (button) setPreviewStep(button.dataset.sidebarPreviewStep);
    });

    state.dom.previewImage.addEventListener('error', () => {
      state.dom.previewImage.hidden = true;
      state.dom.previewBrand.hidden = false;
    });

    state.panelObserver = new MutationObserver(() => {
      if (!state.dom.panel.hidden && state.dom.panel.classList.contains('is-active')) {
        animateOpen();
      }
    });
    state.panelObserver.observe(state.dom.panel, { attributes: true, attributeFilter: ['hidden', 'class'] });
  }

  function init(options) {
    const next = options || {};
    state.disabled = !!next.disabled;
    state.appVersion = Number(next.appVersion) || 0;
    state.handlers = next.handlers || {};

    if (!state.initialized) {
      cacheDom();
      if (!state.dom.panel) return;
      bindEvents();
      state.saved = normalizeSidebar(null);
      state.draft = cloneSidebar(state.saved);
      state.couponRulesSaved = normalizeCouponRules(null);
      state.couponRulesDraft = cloneCouponRules(state.couponRulesSaved);
      state.initialized = true;
    }

    renderAll();
  }

  function sync(config) {
    const source = config && typeof config === 'object' ? config : {};
    const menu = source.menu && typeof source.menu === 'object' ? source.menu : {};
    state.appVersion = Number(source.appVersion) || state.appVersion;
    state.checkoutStore = String(source.checkoutStore || '').trim().toLowerCase();
    state.primaryColor = normalizeColor(source.primaryColor, DEFAULT_COLOR);
    state.saved = normalizeSidebar(menu.sidebar);
    state.draft = cloneSidebar(state.saved);
    renderAll();
  }

  function syncCouponRules(value) {
    state.couponRulesSaved = normalizeCouponRules(value);
    state.couponRulesDraft = cloneCouponRules(state.couponRulesSaved);
    renderAll();
  }

  window.AppMenuSidebar = {
    init,
    sync,
    syncCouponRules,
  };
})();
